import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { GlobalEventBusService, IDeviceContract } from '@nx-fe/services';
import { Subject, Subscription } from 'rxjs';
import { GlobalEvents } from 'sspapp/core/global-event-constants';
import { DeviceContextService } from 'sspapp/services/device-context.service';

@Component({
  selector: 'ssp-devices-menu',
  templateUrl: './devices-menu.component.html',
  styleUrls: ['./devices-menu.component.scss'],
})
export class DevicesMenuComponent implements OnDestroy {
  public id: string;
  public devices: IDeviceContract[];
  private unsubscribe$ = new Subject<void>();
  private routerSub: Subscription;

  constructor(
    public deviceContextService: DeviceContextService,
    private globalEventBusService: GlobalEventBusService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.deviceContextService.reloadDevicesSsp()

    this.routerSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.route.snapshot.firstChild.routeConfig.path === "device/:id")
        {
          this.id = this.route.snapshot.firstChild.params['id'];
        }
        else
        {
          this.id = undefined;
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();

    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  onDeviceClick(device: IDeviceContract) {
    this.globalEventBusService.broadcast(GlobalEvents.selectedDevice, {deviceId: device.deviceId});
    this.router.navigate(['/home/device/' + device.deviceId + '/overview']);
  }

}
